import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Icon, Table } from 'semantic-ui-react'

class CategoryProductRow extends React.Component {
  /*
    getProductProperty(product, propertyId) {
      console.debug('CategoryProductItem:getProductProperty:product', product);
      const property = (product && product.product_properties && product.product_properties.find(product_property => product_property.property_id === propertyId)) || {};
      return property.value_de;
    }

    getTableRow() {
      const { product, deleteProduct, index, categoryProperties } = this.props;
      return [
        <Table.Cell key={-2} collapsing className='draggable' content={<Icon {...config.icons.draggable} link/>}/>,
        <Table.Cell key={-1}>
          <strong>{product.article_number}</strong><br/>
          {product.title_de}<br/>
          <div className='unobtrusive'>{product.title_fr}</div>
        </Table.Cell>
      ].concat(
        categoryProperties.map((property, index) => (
          <Table.Cell children={this.getProductProperty(product, property.id)}/>
        ))
      ).concat([
        <Table.Cell textAlign='right' key={-99}>
          <Icon
            {...config.icons.unlink}
            onClick={() => {
              deleteProduct(index);
            }}
          />
        </Table.Cell>
      ])
    }
  */

  render() {
    const { product, unlinkProduct, index, dragMarker = {} } = this.props //ownProps
    const { isDragging, connectDragSource, connectDropTarget } = this.props //DragSource,DropTarget
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.index === index) {
      dragIndicator = dragMarker.position
    }

    return connectDragSource(
      connectDropTarget(
        <tr className={classNames([rowClass, dragIndicator])}>
          <Table.Cell
            collapsing
            className="draggable"
            content={<Icon {...config.icons.draggable} link />}
          />
          <Table.Cell>
            <strong>{product.article_number}</strong>
            <br />
            {product.title_de}
            <br />
            <div className="unobtrusive">{product.title_fr}</div>
          </Table.Cell>
          <Table.Cell textAlign="right">
            <Icon
              {...config.icons.unlink}
              onClick={() => {
                unlinkProduct(index)
              }}
            />
          </Table.Cell>
        </tr>
      )
    )
  }
}

CategoryProductRow = DropTarget(
  'CategoryProduct',
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(CategoryProductRow)
CategoryProductRow = DragSource(
  'CategoryProduct',
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(CategoryProductRow)
export default CategoryProductRow



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryProductRow.jsx